import type { InfoListProps } from "./types"
import { twMerge } from "tailwind-merge"
import { InfoListItem } from "./InfoListItem"

export const InfoList = ({ className, children, ...rest }: InfoListProps) => {
  return (
    <ul
      {...rest}
      className={twMerge(
        "flex flex-col divide-y divide-gray-200 rounded-lg border border-gray-200",
        className,
      )}
    >
      {children}
    </ul>
  )
}

InfoList.Item = InfoListItem
